import { ActionTypesEngagement } from "../constants/action-types"


const intitialState = {
    createEngagement:{
        loading: false,
        // @ts-ignore
        error : null,
    },
    terminateEngagement:{
        loading: false,
        // @ts-ignore
        error:null,
    },
    // @ts-ignore
    data:null,
    params:{}
}

export const engagementReducer = (state=intitialState,action)=>{
    switch(action.type){
        case ActionTypesEngagement.CREATE_ENGAGEMENT_REQUEST:{
            return {
                ...state,
                createEngagement:{
                    loading:true,
                    error:null,
                },
                data:null,
               
            }
        }

        case ActionTypesEngagement.CREATE_ENGAGEMENT_ERROR:{
            return {
                ...state,
                createEngagement:{
                    loading:false,
                    error:action.payload.error,
                }
            }
        }

        case ActionTypesEngagement.CREATE_ENGAGEMENT_SUCCESS:{
            return {
                ...state,
                createEngagement:{
                    ...state.createEngagement,
                    loading:false
                },
                data:action.payload.data
            }
        }
    
        default:{
            return state;
        }
    }
}



